"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DailyGoalType = void 0;
var DailyGoalType;
(function (DailyGoalType) {
    DailyGoalType["CompleteOnboardingTutorial"] = "COMPLETE_ONBOARDING_TUTORIAL";
    DailyGoalType["CompletePronunciationLesson"] = "COMPLETE_PRONUNCIATION_LEVEL";
    DailyGoalType["CompleteReviewSession"] = "COMPLETE_REVIEW_SESSION";
    DailyGoalType["CreateSimpleWordFlashcard"] = "CREATE_SIMPLE_WORD_FLASHCARD";
    DailyGoalType["CreateSimpleWordOrGrammarFlashcard"] = "CREATE_SIMPLE_WORD_OR_GRAMMAR_FLASHCARD";
    DailyGoalType["SetStudyReminderTime"] = "SET_STUDY_REMINDER_TIME";
})(DailyGoalType = exports.DailyGoalType || (exports.DailyGoalType = {}));
//# sourceMappingURL=daily_goals.js.map